import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSiteSettings } from "@/hooks/useSiteSettings";

export default function ContactCta() {
  const { t } = useTranslation();
  const { contactDetails, contactDisplay } = useSiteSettings();
  const phone = contactDetails.find((c) => c.type === "phone");

  return (
    <section className="w-full">
      <div
        className="relative w-full bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Dark%20automotive%20garage%20workshop%20interior%20with%20tools%20and%20a%20lifted%20vehicle%2C%20moody%20charcoal%20tone%20with%20warm%20golden%20light%20accents%2C%20industrial%20professional%20automotive%20parts%20business&width=1600&height=800&seq=apex-cta&orientation=landscape')",
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-semibold uppercase text-white">
            {t("cta.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm md:text-base text-white/70 leading-relaxed">
            {t("cta.desc")}
          </p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/contact-us"
              className="flex items-center gap-2 rounded-md bg-brand-gold px-7 py-3 text-sm font-semibold uppercase tracking-wide text-brand-dark transition hover:bg-white whitespace-nowrap"
            >
              <i className="ri-message-3-line"></i>
              {t("cta.request")}
            </Link>
            {contactDisplay.phone_contact_cta && phone && (
              <a
                href={`tel:${phone.value.replace(/\s/g, "")}`}
                className="flex items-center gap-2 rounded-md border border-white/40 px-7 py-3 text-sm font-semibold uppercase tracking-wide text-white transition hover:border-brand-gold hover:text-brand-gold whitespace-nowrap"
              >
                <i className="ri-phone-line"></i>
                {phone.value}
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}